import { defineMessages } from 'react-intl';

export default defineMessages({
  Heading: {
    id: 'Apply.Heading',
    defaultMessage: 'Job Application',
  },
  DefaultJobTitle: {
    id: 'Apply.DefaultJobTitle',
    defaultMessage: 'Position {jobId}',
  },
});
